import React, { useRef } from 'react';
import { RecordingHeaderWithRouteGuard } from './RecordingHeaderWithRouteGuard';
import { RecorderBody } from './RecorderBody';
import { RECORDING_STATUS } from './types';
import useRecorder from './useRecorder';
import VideoRecorderActions from './VideoRecorderActions';
import { IPlayerDesign } from 'queries/videoReply/types';
import { VideoPreviewReply } from './VideoPreviewReply';

interface ScreenRecorderProps {
  screenStream: MediaStream;
  stopAllStreams: () => void;
  handleGoToRecordHome: () => void;
  showPreview?: boolean;
  onStartUpladingVoiceOverHandler?: (blob: Blob) => void;
  playerDesign?: IPlayerDesign;
}

export const ScreenRecorder = ({
  screenStream,
  stopAllStreams,
  handleGoToRecordHome,
  showPreview = true,
  onStartUpladingVoiceOverHandler,
  playerDesign,
}: ScreenRecorderProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const {
    stopRecording,
    pauseRecording,
    startCountDown,
    stopCountDown,
    status,
    recordedBlob,
    countdown,
    timeInSeconds,
  } = useRecorder({
    screenStream,
    stopAllStreams,
    onStartUpladingVoiceOverHandler,
    shouldStartCountdown: true,
    videoRef,
    handleGoToRecordHome,
  });

  if (status === RECORDING_STATUS.DONE && recordedBlob && showPreview) {
    return (
      <VideoPreviewReply
        videoBlob={recordedBlob}
        handleGoToRecordHome={handleGoToRecordHome}
        playerDesign={playerDesign}
      />
    );
  }

  return (
    <>
      <RecordingHeaderWithRouteGuard
        status={status}
        handleGoToRecordHome={handleGoToRecordHome}
      />

      <RecorderBody videoRef={videoRef} countdown={countdown} status={status} />
      <VideoRecorderActions
        startCountDown={startCountDown}
        stopCountDown={stopCountDown}
        pauseRecording={pauseRecording}
        stopRecording={stopRecording}
        status={status}
        timeInSeconds={timeInSeconds}
      />
    </>
  );
};
